import { defineStore } from 'pinia'
// 全局store 用于处理全局操作
export const useGlobalStore = defineStore('global', {
  state: () => {
    return {
      refreshFlag: true, // main层刷新
      frameCode: '', // iframeCode
      showCityPriceDialog: false, // 显示城市价格弹窗
      cityPriceAdjustId: '' // 城市调价id
    }
  },
  actions: {
    refresh() {
      this.refreshFlag = false
      setTimeout(() => {
        this.refreshFlag = true
      })
    },
    setFrameCode(code: string) {
      this.frameCode = code
    },
    setShowCityPriceDialog(flag: boolean) {
      this.showCityPriceDialog = flag
    },
    setCityPriceAdjustId(id: string) {
      this.cityPriceAdjustId = id
    }
  }
})
